<!--
 * @Author: wangzhu10 wangzhu10@jd.com
 * @Date: 2022-06-24 15:02:07
 * @LastEditors: wangzhu10 wangzhu10@jd.com
 * @LastEditTime: 2022-07-07 16:24:35
-->
<template>
  <div class="select-other-wrapper">
    <div class="top">
      <van-search
        v-model="erp"
        @input="handleSearch()"
        shape="round"
        autofocus
        class="search-input"
        placeholder="请输入erp搜索" />
      <span @click="handleCancle" class="cancel-btn">取消</span>
    </div>
    <div v-if="list.length && !loading" class="erp-list">
      <div v-for="item in list" :key="item.userName">
        <div class="list-item">
          <van-image
            round
            width="1rem"
            height="1rem"
            class="item-avatar"
            :src="item.headImg"
          />
          <div @click="handleSelectErp(item)" class="item-info">
            <div>
              <span>{{item.realName}}</span>
              <span class="label">（{{item.userName}}）</span>
            </div>
            <div class="ellip label item-org">{{item.nodeFullname}}</div>
          </div>
        </div>
        <van-divider />
      </div>
    </div>
    <van-loading v-else-if="!list.length && loading" size="24px" vertical>加载中...</van-loading>
    <van-empty v-else description="未搜索到相关人员" />
  </div>
</template>

<script>
import api from '../../../api/index'
import { throttle } from '../../../utils/lib'

export default {
  data() {
    return {
      erp: '',
      loading: false,
      list: []
    }
  },
  created() {
    // this.fetchErpList()
  },
  methods: {
    fetchErpList() {
      this.list = []
      if (this.erp) {
        this.loading = true
        const params = { erp: this.erp }   
        api.getErps(params).then(res => {
          this.loading = false
          const { code, data } = res
          if (code === 200) {
            this.list = data
          }
        })
      }
    },
    handleSelectErp(item) {
      this.$emit('select', item)
    },
    handleSearch: throttle(function() {
      this.fetchErpList()
    }, 1000),
    handleCancle() {
      this.$emit('cancle')
    }
  }
}
</script>

<style lang="less" scoped>
.select-other-wrapper {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: #fff;
  z-index: 9999;
  font-size: 14px;
  height: 100vh;
  overflow: hidden;
  .erp-list {
    overflow-y: auto;
    height: 100%;
    padding-bottom: 70px;
    box-sizing: border-box;
  }
  .top {
    display: flex;
    align-items: center;
    // padding: 0 16px;
    margin-right: 14px;
    .search-input {
      flex: 1;
    }
  }
  .list-item {
    display: flex;
    padding: 5px 20px;
    text-align: left;
  }
  .item-info {
    margin-left: 10px;
  }
  .item-avatar {
    flex-shrink: 0;
  }
  .ellip {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    width: 290px;
  }
  .label {
    color: #606266;
  }
  .item-org {
    font-size: 12px;
  }
  /deep/ .van-divider {
    margin: 10px;
  }
  .cancel-btn {
    color: #2695F1;
  }
}
</style>
